import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitePublicAmenity } from '../../../core/models/site-public-profile.model';
import { SITE_AMENITY_META, isKnownAmenity } from '../../../core/utils/site-amenity.util';

interface AmenityView {
  code: string;
  icon: string;
  label: string;
  note: string;
}

/**
 * ไอคอนความเชื่อมั่นของลาน
 * - icons: วงกลมเล็ก (การ์ด Home / รายการค้นหา) — ใช้ codes
 * - chips: ป้าย icon + ชื่อ (Modal แผนที่)
 * - grid: การ์ดพร้อมข้อความเสริม (หน้า /lot)
 */
@Component({
  selector: 'app-site-amenities',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './site-amenities.component.html',
  styleUrl: './site-amenities.component.css',
})
export class SiteAmenitiesComponent implements OnChanges {
  @Input() amenities: SitePublicAmenity[] | null = null;
  @Input() codes: string[] | null = null;
  @Input() lang: string = 'TH';
  @Input() variant: 'icons' | 'chips' | 'grid' = 'chips';
  @Input() max = 0;

  items: AmenityView[] = [];
  hiddenCount = 0;

  ngOnChanges(): void {
    const all = this.buildItems();
    const limit = this.max > 0 ? this.max : all.length;
    this.items = all.slice(0, limit);
    this.hiddenCount = Math.max(0, all.length - limit);
  }

  trackByCode(_: number, item: AmenityView): string {
    return item.code;
  }

  private buildItems(): AmenityView[] {
    const isEn = this.lang === 'EN';
    if (this.amenities?.length) {
      return this.amenities
        .filter((a) => isKnownAmenity(a.code))
        .map((a) => {
          const meta = SITE_AMENITY_META[a.code];
          const label = (isEn ? a.labelEn : a.labelTh) || (isEn ? meta.en : meta.th);
          const note = (isEn && a.noteEn?.trim() ? a.noteEn : a.noteTh) || '';
          return { code: a.code, icon: meta.icon, label, note: note.trim() };
        });
    }

    return (this.codes ?? [])
      .filter((c) => isKnownAmenity(c))
      .map((c) => {
        const meta = SITE_AMENITY_META[c.toLowerCase()];
        return { code: c, icon: meta.icon, label: isEn ? meta.en : meta.th, note: '' };
      });
  }
}
